/******************************************************************************
 *
 * Copyright (c) 2019-2023 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Rahul Bagaria' <Rahul@wakencode.com>, September 2023
 *
 *****************************************************************************/

import "./index.css";
import { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { Loading } from "./views/components/loading";
import { Layout } from "./views/components/layout";

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {    
    setTimeout(() => setLoading(false), 1000);
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <BrowserRouter>      
      <Layout />      
    </BrowserRouter>
  );
};

export default App;
